import React from "react";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import { Grid } from "components/Containers";
import { Spinner } from "components/Loader";
import { useMissionRoleTemplates, useRoleBuilderContext } from "hooks";
import { ROLE_BUILDER_CONFIG } from "constants/index";
import { margins } from "style";
import { BlueprintCard } from "components/Missions/Roles/TalentSimple/RoleBuilder";

/**
 * BlueprintPicker
 */
const BlueprintPicker = () => {
  const { blueprintId, applyingBlueprint, selectBlueprint } = useRoleBuilderContext();
  const { templates, loading } = useMissionRoleTemplates();

  return (
    <div css={styles.container}>
      {loading && <Spinner />}
      {!loading && templates.length === 0 && (
        <FormattedMessage id="Missions.Roles.TalentSimple.RoleBuilder.Blueprint.Empty" />
      )}
      {!loading && templates.length > 0 && (
        <Grid cols={ROLE_BUILDER_CONFIG.BLUEPRINT_COLUMNS} gap="2rem">
          {templates.map((template) => (
            <BlueprintCard
              key={template.uuid}
              template={template}
              isSelected={template.uuid === blueprintId}
              applying={applyingBlueprint}
              onSelect={selectBlueprint}
            />
          ))}
        </Grid>
      )}
    </div>
  );
};

const styles = {
  container: css`
    order: 2;
    margin-top: ${margins.xxsmall};
  `,
};

export default BlueprintPicker;
